import React from 'react';
import ReactDOM from 'react-dom/client';
import Main from './Main';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('site-main'));
root.render(
    
    <Main />
    
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
